import React from "react";

const Img = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2 6.5C2 7.64895 2.55376 8.66802 3.4074 9.30572C3.14391 9.98931 3 10.7276 3 11.5C3 15.1268 6.17244 18 10 18C13.8276 18 17 15.1268 17 11.5C17 10.7272 16.856 9.98862 16.5922 9.30476C17.4451 8.66705 17.9984 7.64837 17.9984 6.5C17.9984 4.567 16.4313 3 14.4984 3C13.0588 3 11.8232 3.86878 11.2855 5.10986C10.8681 5.03768 10.4383 5 10 5C9.56113 5 9.13087 5.03778 8.71302 5.11013C8.17535 3.86889 6.93967 3 5.5 3C3.567 3 2 4.567 2 6.5ZM5.5 4C6.46676 4 7.30622 4.54905 7.72207 5.35296C6.06965 5.88139 4.68799 6.96899 3.85446 8.38221C3.33024 7.92356 3 7.25012 3 6.5C3 5.11929 4.11929 4 5.5 4ZM12.2765 5.3525C12.6925 4.54883 13.5318 4 14.4984 4C15.8791 4 16.9984 5.11929 16.9984 6.5C16.9984 7.24961 16.6686 7.92259 16.145 8.38125C15.3111 6.96809 13.9292 5.88064 12.2765 5.3525ZM10 6C13.3521 6 16 8.49936 16 11.5C16 12.7318 15.5538 13.8791 14.7959 14.8037C13.853 13.1307 12.0596 12 10.0011 12C7.942 12 6.14806 13.1314 5.20551 14.8053C4.44673 13.8804 4 12.7325 4 11.5C4 8.49936 6.64786 6 10 6ZM14.0584 15.5508C12.9958 16.4478 11.5757 17 10 17C8.42511 17 7.00568 16.4483 5.94325 15.5522C6.48171 14.4325 7.4697 13.5705 8.67265 13.1993C8.92403 13.6755 9.42412 14 10 14C10.5761 14 11.0764 13.6752 11.3277 13.1987C12.531 13.5694 13.5195 14.4312 14.0584 15.5508Z"
        fill="#fff"
      />
      <path
        d="M5.5 23C3.567 23 2 24.567 2 26.5C2 27.2563 2.23994 27.9563 2.6474 28.5283C3.64548 26.3566 5.7022 24.7532 8.14279 24.2054C7.50128 23.467 6.55546 23 5.5 23Z"
        fill="#212121"
      />
      <path
        d="M17.9985 26.5C17.9985 27.2557 17.7589 27.9552 17.352 28.527C16.3535 26.3556 14.2966 24.7525 11.8559 24.2051C12.4974 23.4669 13.4432 23 14.4985 23C16.4315 23 17.9985 24.567 17.9985 26.5Z"
        fill="#212121"
      />
      <path
        d="M3 31.5C3 27.8732 6.17244 25 10 25C13.8276 25 17 27.8732 17 31.5C17 33.1654 16.331 34.6719 15.2369 35.8143C14.5251 33.6014 12.4496 32 10 32C7.55044 32 5.4749 33.6014 4.76313 35.8143C3.66896 34.6719 3 33.1654 3 31.5Z"
        fill="#212121"
      />
      <path
        d="M11.3275 33.199C12.8704 33.6747 14.0592 34.9578 14.4006 36.5549C13.1931 37.4609 11.658 38 10 38C8.34201 38 6.80695 37.4609 5.59941 36.5549C5.94077 34.9578 7.12958 33.6747 8.67249 33.199C8.92382 33.6753 9.42399 34 10 34C10.576 34 11.0762 33.6753 11.3275 33.199Z"
        fill="#212121"
      />
    </svg>
  );
};

export default Img;
